// system-setting.store.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SystemSettings {
  logos: any[];
  favicons: any[];
  banners: any[];
  hotline: string;
  videoLink: string;
  email: string;
}

@Injectable({
  providedIn: 'root',
})
export class SystemSettingStore {
  private settingsSubject = new BehaviorSubject<SystemSettings>({
    logos: [],
    favicons: [],
    banners: [],
    hotline: '',
    videoLink: '',
    email: '',
  });

  readonly settings$ = this.settingsSubject.asObservable();

  updateSettings(partial: Partial<SystemSettings>) {
    const current = this.settingsSubject.value;
    this.settingsSubject.next({
      ...current,
      ...partial,
    });
  }

  get snapshot() {
    return this.settingsSubject.value;
  }
}
